export default defineNuxtRouteMiddleware((to) => {
  // Get auth configuration
  const config = useRuntimeConfig();
  const isAuthEnabled = config.public.auth.isEnabled;

  // If auth is disabled, skip authentication check
  if (!isAuthEnabled) {
    return;
  }

  const { $localeRootPath } = useNuxtApp();
  const { loggedIn, user } = useUserSession();

  // Only apply to base account route (exclude subpages)
  if (
    to.path === '/account' ||
    to.path.endsWith('/account/') ||
    to.path.match(/\/(de|fr|en|nl|ch-de|ch-fr)\/account\/?$/)
  ) {
    // Redirect to profile details
    return navigateTo($localeRootPath('/account/profile/details'));
  }

  // Skip auth check for login, register, and password reset pages
  const publicPages = [
    '/account/login',
    '/account/register',
    '/account/reset',
    '/account/passwordReset',
    '/account/verifyEmail',
  ];
  const isPublicPage = publicPages.some((page) => to.path.includes(page));

  if (isPublicPage) {
    // If going to login page while logged in, redirect to profile
    if (to.path.includes('/account/login') && loggedIn.value) {
      return navigateTo($localeRootPath('/account/profile/details'));
    }
    return; // Allow access to public pages
  }

  // If not logged in and accessing protected route
  if (!loggedIn.value) {
    // Store the current path for redirect after login
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('fromUri', window.location.origin + to.fullPath);
    }

    return navigateTo($localeRootPath ? $localeRootPath('/account/login') : '/account/login');
  }

  // Verified user check for specific pages
  const needsVerification = to.path.includes('/account/exercises') || to.path.includes('/account/workouts');

  if (needsVerification && user.value && !user.value.isVerified) {
    return navigateTo($localeRootPath('/account/profile/details'));
  }
});
